import { setSelectedRowKeys } from '../../../State/selectedRowKeys';

export default (selectedRowKeys) => async (dispatch) => dispatch(setSelectedRowKeys(selectedRowKeys));